import {
  MESSAGES_TAB,
  MYSELF_TAB,
  STORYLET_TAB,
} from '../actiontypes/subtabs';

export function setTab({ tab, subtab }) {
  return (dispatch) => {
    if (tab === 'storylet') {
      return dispatch({ type: STORYLET_TAB, payload: subtab });
    }
    if (tab === 'messages') {
      return dispatch({ type: MESSAGES_TAB, payload: subtab });
    }
    return dispatch({ type: MYSELF_TAB, payload: subtab });
  };
}